import React from 'react'

import Box from 'app/components/base/Box'

const ListingInfoContainer: RFC = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'background.default',
        width: '100%',
        px: { md: 0, xs: 2 },
        py: '0px !important',
        boxShadow: {
          xs: '0px -12px 24px -4px rgba(145, 158, 171, 0.15), 0px -1px 2px rgba(199, 207, 216, 0.7)',
          md: 'none'
        },
        maxWidth: { md: 400, sm: '100%' },
        pt: { xs: '24px !important', md: '0px !important' },
        borderColor: { xs: 'stroke.main', md: 'none' },
        borderTopLeftRadius: { xs: '16px', md: 'none' },
        borderTopRightRadius: { xs: '16px', md: 'none' }
      }}
    >
      {children}
    </Box>
  )
}

export default ListingInfoContainer
